import useDesignSystemStore, {
  GenerationStatus,
} from "@/store/zustand/aiDesignSystemBuilder";

import ExamplesViewer from "@/components/DesignSystemBuilder/components/ExamplesViewer";
import FileViewer from "@/components/DesignSystemBuilder/components/FileViewer";
import StoriesViewer from "@/components/DesignSystemBuilder/components/StoriesViewer";
import PropsViewer from "@/components/DesignSystemBuilder/components/PropsViewer";
import EditableWrapper, { InputType } from "./EditableWrapper";
import React from "react";

const GenerationContext = () => {
  const status = useDesignSystemStore((state) => state.generation.status);
  const {
    selectedFiles,
    componentOverview,
    examples,
    notes,
    name,
    props,
    stories,
  } = useDesignSystemStore((state) => state.generation.context);

  const setComponentOverview = useDesignSystemStore(
    (state) => state.setComponentOverview
  );

  const setNotes = useDesignSystemStore((state) => state.setNotes);
  const setName = useDesignSystemStore((state) => state.setName);

  return (
    <div className="flex flex-col gap-4">
      {name.length > 0 && (
        <div className="flex flex-col gap-2">
          <div className="font-bold text-xs">Name</div>
          <EditableWrapper
            value={name}
            onEdit={setName}
            disabled={status !== GenerationStatus.Editing}
          >
            <div className="text-2xs">{name}</div>
          </EditableWrapper>
        </div>
      )}
      {componentOverview.length > 0 && (
        <div className="flex flex-col gap-2">
          <div className="font-bold text-xs">Description</div>
          <EditableWrapper
            value={componentOverview}
            onEdit={setComponentOverview}
            disabled={status !== GenerationStatus.Editing}
            type={InputType.TEXTAREA}
          >
            <div className="text-2xs">{componentOverview}</div>
          </EditableWrapper>
        </div>
      )}
      {selectedFiles.length > 0 && (
        <div className="flex flex-col gap-2">
          <div className="font-bold text-xs">Files</div>
          <FileViewer />
        </div>
      )}
      {examples.length > 0 && (
        <div className="flex flex-col gap-2">
          <div className="font-bold text-xs">Examples</div>
          <ExamplesViewer />
        </div>
      )}
      {props.length > 0 && (
        <div className="flex flex-col gap-2">
          <div className="font-bold text-xs">Props</div>
          <PropsViewer />
        </div>
      )}
      {stories.length > 0 && (
        <div className="flex flex-col gap-2">
          <div className="font-bold text-xs">Stories</div>
          <StoriesViewer />
        </div>
      )}
      <div className="flex flex-col gap-2">
        <div className="font-bold text-xs">Notes</div>
        <EditableWrapper
          value={notes}
          onEdit={setNotes}
          type={InputType.TEXTAREA}
        >
          <div className="text-2xs">{notes || "Add notes"}</div>
        </EditableWrapper>
      </div>
    </div>
  );
};

export default React.memo(GenerationContext);
